import {
  AccountingConnection,
  AccountingVendor,
  LedgerAccount
} from "@wingspanhq/wingspan-api-sdk";
import { IFeatureFlags } from "@hooks/useQueryFeatureFlags";
import { selectorIsQuickbooksConnectionSynced } from "./selectorIsQuickbooksConnectionSynced";

export interface PayeeQboMappingInput {
  featureFlags?: IFeatureFlags;
  connection?: AccountingConnection;
  vendors?: AccountingVendor[];
  expenseAccounts?: LedgerAccount[];
}

/**
 * Whether the payee QuickBooks mapping fields have anything to offer: a
 * QuickBooks connection exists and is usable, and its reference data actually
 * holds vendors and expense accounts to map onto.
 *
 * The v3 shape of the same predicate v1 built from `selectorIsQBOActive` over
 * `GET /integrations/quickbooks/service`: `connection` replaces `qboService`
 * (derived via `selectorQuickbooksConnection`), and
 * `selectorIsQuickbooksConnectionSynced` replaces `isQuickbooksServiceActive`.
 * `forceShowQBO` still bypasses the sync check but not the connection itself.
 */
export const selectorIsPayeeQboMappingEnabled = ({
  featureFlags,
  connection,
  vendors,
  expenseAccounts
}: PayeeQboMappingInput): boolean =>
  Boolean(
    connection &&
    (featureFlags?.forceShowQBO ||
      selectorIsQuickbooksConnectionSynced(connection)) &&
    (vendors?.length ?? 0) > 0 &&
    (expenseAccounts?.length ?? 0) > 0
  );
